export const ANALYZING_REFRESH_INTERVAL_MS = 3000;
export const LIVE_REFRESH_INTERVAL_MS = 30000;
